import React, { useContext } from 'react';
import LocalizationContext from '../../Localization/LanguageContext';
import { ILocalizationContext } from '../../Localization/Models/ILocalizationContext';
import { Button } from '@saif/button';
import './styles.css';

interface Props {
  className?: string;
}

const LanguageSelect = ({ className }: Props) => {
  const { getValue, setLocale, locale } = useContext(
    LocalizationContext
  ) as ILocalizationContext;

  const LanguageSwap = () => {
    setLocale((prev) => (prev === 'en' ? 'es' : 'en'));
    localStorage.setItem('SAIFLanguage', locale === 'en' ? 'es' : 'en');
  };

  return (
      <Button variant='text' color='primary' className='language-select' size='sm' iconProps={{ variant: 'language'}} onClick={LanguageSwap}>
          {getValue('LanguageSelect', 'Toggle')}
      </Button>
  );
};

export default LanguageSelect;
